import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzNotificationsModule } from '@blk/daisy/combinations/notifications';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzCheckboxModule, DzToggleSwitchModule } from '@blk/daisy/elements/selection-controls';
import { ReportComposerModule } from '@blk/simba';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DialogModule, DialogService } from '@ddt-web/dialog';
import { DomModule } from '@ddt-web/dom';
import { ActionsDrawerModule } from '@ddt-web/elements';
import { EmailDomainCustomizationModule } from '@ddt-web/email-domain-customization';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { PdfUtilsModule } from '@ddt-web/pdf-utils';
import { ProposalModule } from '@ddt-web/proposal';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { PdfReportConfigService } from '../services/pdf-report-config.service';
import { CropperComponent } from './cropper/cropper.component';
import { SafeSvgContentDirective } from './directives/safe-svg-content.directive';
import { PdfBenchmarkOptionComponent } from './pdf-benchmark-option/pdf-benchmark-option.component';
import { PdfBpasReportDetailsComponent } from './pdf-bpas-report-details/pdf-bpas-report-details.component';
import { PdfCustomPageComponent } from './pdf-custom-page/pdf-custom-page.component';
import { PdfFrontDisclosureOptionsComponent } from './pdf-front-disclosure-options/pdf-front-disclosure-options.component';
import { PdfFundFilteringComponent } from './pdf-generate/pdf-fund-filtering/pdf-fund-filtering.component';
import { PdfGenerateSkeletonComponent } from './pdf-generate/pdf-generate-skeleton/pdf-generate-skeleton.component';
import { PdfGenerateComponent } from './pdf-generate/pdf-generate.component';
import { PdfLogoUploadComponent } from './pdf-logo-upload/pdf-logo-upload.component';
import { PdfPortfoliosHeaderComponent } from './pdf-portfolios-header/pdf-portfolios-header.component';
import { PdfReportCustomizationComponent } from './pdf-report-customization/pdf-report-customization.component';
import { PdfReportDetailsComponent } from './pdf-report-details/pdf-report-details.component';
import { PdfReportModelsFilterComponent } from './pdf-report-models-filter/pdf-report-models-filter.component';
import { PdfYieldOptionsComponent } from './pdf-yield-options/pdf-yield-options.component';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
	// Url needs to be non empty string
	// Change this to your upload POST address:
	url: ' ',
	acceptedFiles: 'image/*',
	autoProcessQueue: false
};

@NgModule({
	imports: [
		CommonModule,
		ActionsDrawerModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		ReportComposerModule,
		DataServiceModule,
		DropzoneModule,
		DomModule,
		DialogModule,
		PdfUtilsModule,
		ProposalModule,
		RouterModule.forChild([{ path: '', component: PdfGenerateComponent }]),
		CwpNgFrameworkModule,
		AnalyticsModule,
		EmailDomainCustomizationModule,
		NgxSkeletonLoaderModule,
		DzNotificationsModule,
		DzCheckboxModule,
		DzToggleSwitchModule,
		DzButtonModule,
		GenericDirectivesModule,
		DzProgressSpinnerModule,
		DzIconModule.withIcons(faArrowDown)
	],
	declarations: [
		PdfGenerateComponent,
		PdfYieldOptionsComponent,
		PdfPortfoliosHeaderComponent,
		PdfReportDetailsComponent,
		PdfLogoUploadComponent,
		PdfReportCustomizationComponent,
		PdfCustomPageComponent,
		PdfBpasReportDetailsComponent,
		PdfFrontDisclosureOptionsComponent,
		PdfBenchmarkOptionComponent,
		CropperComponent,
		PdfGenerateSkeletonComponent,
		PdfFundFilteringComponent,
		PdfReportModelsFilterComponent,
		SafeSvgContentDirective
	],
	providers: [
		{
			provide: DROPZONE_CONFIG,
			useValue: DEFAULT_DROPZONE_CONFIG
		},
		PdfReportConfigService,
		DialogService
	]
})
export class PdfGenerateModule { }
